const visibleWhatsAppObservationsIdsReducer = (observationIds = [], action) => {
    switch(action.type){
        case 'CHANGE_VISIBLE_WHATSAPP_OBSERVATIONS_IDS':
            return action.data;
        default:
            return observationIds;
    }
}

export default visibleWhatsAppObservationsIdsReducer;
